import React, { useState, useEffect } from "react";
import { db } from "../firebaseConfig";
import { doc, getDoc, updateDoc, deleteDoc } from "firebase/firestore";
import Toast from "./Toast"; // Import Toast component
import "./form.css"; // Import your CSS styles

const EditStockForm = () => {
  const [stockId, setStockId] = useState("");
  const [scrip, setScrip] = useState("");
  const [date, setDate] = useState("");
  const [rate, setRate] = useState("");
  const [quantity, setQuantity] = useState("");
  const [transactionType, setTransactionType] = useState("BUY");
  const [amount, setAmount] = useState("");

  const [showToast, setShowToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [toastType, setToastType] = useState("success");
  const [partner, setPartner] = useState("Personal");
  const [isEditing, setIsEditing] = useState(false) // Track whether editing mode is enabled

  useEffect(() => {
    if (rate && quantity) {
      const baseAmount = rate * quantity;
      const charges = baseAmount * 0.0036;

      const finalAmount =
        transactionType === "BUY"
          ? baseAmount + charges
          : baseAmount - charges;

      setAmount(finalAmount.toFixed(2));
    } else {
      setAmount("");
    }
  }, [rate, quantity, transactionType]);

  // Fetch stock data by stock ID
  const fetchStockData = async () => {
    if (!stockId) {
      setToastMessage("Please provide a stock ID");
      setToastType("error");
      setShowToast(true);
      setTimeout(() => setShowToast(false), 3000);
      return;
    }

    try {
      const docRef = doc(db, "transactions", stockId);
      const docSnap = await getDoc(docRef);

      if (docSnap.exists()) {
        const stockData = docSnap.data();
        setScrip(stockData.scrip);
        setDate(stockData.date);
        setRate(stockData.rate);
        setQuantity(stockData.quantity);
        setTransactionType(stockData.transactionType);
        setAmount(stockData.amount);
        setPartner(stockData.partner || "Personal");
        setIsEditing(true); // Enable editing mode
        setToastMessage("Data fetched successfully!");
        setToastType("success");
        setShowToast(true);
      } else {
        setToastMessage("No stock found with that ID");
        setToastType("error");
        setShowToast(true);
      }

      setTimeout(() => setShowToast(false), 3000);
    } catch (error) {
      console.error("Error fetching document: ", error);
      setToastMessage("Error fetching data");
      setToastType("error");
      setShowToast(true);
      setTimeout(() => setShowToast(false), 3000);
    }
  };

  // Handle form submission to update data
  const handleUpdate = async (e) => {
    e.preventDefault();
    try {
      const docRef = doc(db, "transactions", stockId);
      await updateDoc(docRef, {
        scrip,
        date,
        rate: parseFloat(rate),
        quantity: parseInt(quantity),
        transactionType,
        amount: parseFloat(amount),
        partner
      });

      setToastMessage("Stock updated successfully!");
      setToastType("success");
      setShowToast(true);
      setTimeout(() => setShowToast(false), 3000);

      // Reset form fields
      setStockId("");
      setScrip("");
      setDate("");
      setRate("");
      setQuantity("");
      setTransactionType("BUY");
      setAmount("");
      setPartner("Personal");
      setIsEditing(false); // Disable editing mode
    } catch (error) {
      console.error("Error updating document: ", error);
      setToastMessage("Error updating stock");
      setToastType("error");
      setShowToast(true);
      setTimeout(() => setShowToast(false), 3000);
    }
  };

  // Handle delete
  const handleDelete = async () => {
    try {
      await deleteDoc(doc(db, "transactions", stockId));
      setToastMessage("Stock deleted successfully!");
      setToastType("success");
      setShowToast(true);
      setTimeout(() => setShowToast(false), 3000);

      // Reset form fields
      setStockId("");
      setScrip("");
      setDate("");
      setRate("");
      setQuantity("");
      setTransactionType("BUY");
      setAmount("");
      setIsEditing(false); // Disable editing mode
    } catch (error) {
      console.error("Error deleting document: ", error);
      setToastMessage("Error deleting stock");
      setToastType("error");
      setShowToast(true);
      setTimeout(() => setShowToast(false), 3000);
    }
  };

  return (
    <div>
      {/* Input field to enter stock ID and fetch data */}
      <div>
        <label>Stock ID:</label>
        <input
          type="text"
          value={stockId}
          onChange={(e) => setStockId(e.target.value)}
          required
        />
        <button onClick={fetchStockData}>Fetch Stock Data</button>
      </div>

      {isEditing && (
        <form onSubmit={handleUpdate}>
          <div>
            <label>Scrip:</label>
            <input
              type="text"
              value={scrip}
              onChange={(e) => setScrip(e.target.value)}
              required
            />
          </div>

          <div>
            <label>Date:</label>
            <input
              type="date"
              value={date}
              onChange={(e) => setDate(e.target.value)}
              required
            />
          </div>

          <div>
            <label>Rate:</label>
            <input
              type="number"
              value={rate}
              onChange={(e) => setRate(e.target.value)}
              required
            />
          </div>

          <div>
            <label>Quantity:</label>
            <input
              type="number"
              value={quantity}
              onChange={(e) => setQuantity(e.target.value)}
              required
            />
          </div>

          <div>
            <label>Transaction Type:</label>
            <select
              value={transactionType}
              onChange={(e) => setTransactionType(e.target.value)}
            >
              <option value="BUY">Buy</option>
              <option value="SELL">Sell</option>
            </select>
          </div>

          <div>
            <label>{transactionType === "BUY" ? "Bill Amount:" : "Receivable Amount:"}</label>
            <input
              type="number"
              value={amount}
              readOnly
            />
          </div>
          <div>
            <label>Partner:</label>
            <input
              type="text"
              value={partner}
              onChange={(e) => setPartner(e.target.value)}
              placeholder="Enter partner name (default: Personal)"
            />
          </div>

          <button type="submit">Update Stock</button>
          <button type="button" onClick={handleDelete} className="delete-button">
            Delete Stock
          </button>
        </form>
      )}

      {/* Toast notification */}
      <Toast message={toastMessage} type={toastType} show={showToast} />
    </div>
  );
};

export default EditStockForm;
